import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const rocket: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11.031-7.969a.72.72 0 0 0 .219-.531.74.74 0 0 0-.219-.531.74.74 0 0 0-.531-.219.72.72 0 0 0-.531.219.72.72 0 0 0-.219.531c0 .211.07.387.219.531.144.149.32.219.531.219a.72.72 0 0 0 .531-.219M13-10.75q-.002 1.94-.594 3.36-.58 1.423-1.968 2.812-.643.626-1.532 1.375L8.75-.234a.3.3 0 0 1-.125.203l-3 1.75a.24.24 0 0 1-.125.031.28.28 0 0 1-.172-.062l-.5-.5q-.11-.111-.062-.25l.656-2.172-2.188-2.188-2.156.656A.2.2 0 0 1 1-2.75c-.074 0-.133-.023-.172-.078l-.5-.5q-.141-.14-.047-.297l1.75-3a.3.3 0 0 1 .203-.125l2.97-.156q.749-.89 1.374-1.531c.977-.97 1.91-1.633 2.797-2Q10.7-11 12.735-11a.27.27 0 0 1 .187.078q.077.066.078.172m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.244 11)"
    />
  ),
  svgProps: {
    height: "12.75",
    width: "12.756",
  }
};
